/*eslint-disable */
import React, { Component } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import OrderDetails from "./orderDetails";
import RebidModal from "../modals/reBidModal";
import { translate } from "react-i18next";
import ReadAxios from "../../axiosComponent/read";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import VendorName from "./vendorName";
import ModalReason from "../modals/miniRejectStatusModal";
import VehicleType from "./vehicleTypeName";
import CreateAxios from "../../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import FormikModalVehicleDetail from "./vehicleDetails";
import { faReplyAll } from "@fortawesome/free-solid-svg-icons";

export class VendorRepliesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openViewModal: false,
      replies_fetch: null,
      isLoading: true,
      currentOrder: 0,
      broadCastVendor: 0,
      order_id: this.props.orderData.value,
      VehicleFetched: [],
      textareaValues: '',
      errorMessage: ''
    };
  }

  handleModelOpen = (ID) => {
    this.setState({ openViewModal: true, broadCastVendor: ID });
  };

  getvalue = (childData) => {
    if (childData) {
      this.setState({
        textareaValues: childData
      })
      this.bitSumbit(this.state.textareaValues)
    }
  }
  bitSumbit = (message) => {
    if (this.state.textareaValues.length > 1) {
      this.setState({
        openViewModal: false
      })
      CreateAxios({
        completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.orderData.value}/broadcast/vendor/${this.state.broadCastVendor}/rebid`,
        payload: { rebid_note: message },
      })
        .then((res) => {
          this.props.success({
            type: "success",
            messageHeader: "Success",
            messageBody: res.message,
          });
          this.fetchVendorsReply();

        })
        .catch((err) => {
          console.log(err);
          this.props.success({
            type: "error",
            messageHeader: "Error",
            messageBody: err.message,
          });
        });
    } else {
      // this.setState({
      errorMessage: 'Please enter Rebid message'
      this.props.error({
        type: "error",
        messageHeader: "Error",
        messageBody: 'Please enter Rebid message',
      });
      // })
    }
  }
  componentDidMount() {
    this.fetchVendorsReply();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentOrder !== this.state.currentOrder) {
      this.setState({ currentOrder: nextProps.currentOrder }, () =>
        this.fetchVendorsReply()
      );
    }
  }

  reBroadcast = () => {
    console.log("Rebroadcast the same order");
  };

  fetchVendorsReply = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${this.props.orderData.value}/broadcast/vendor/replies`,
    })
      .then((res) => {
        this.setState({
          replies_fetch: res.data.vendor_replies,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (err.response) {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.error.message,
          };
          this.setState(
            {
              isLoading: false,
              replies_fetch: null,
            },
            () => this.props.error(alert)
          );
        }
      });
  };

  getvehicleDetails = (id) => {
    ReadAxios({ url: `vehicleMaster/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? this.setState({ VehicleFetched: [] })
          : this.setState({ VehicleFetched: res.data.resultSet });
      })
      .catch((err) => {
        this.setState({ VehicleFetched: [] });
      });
  };

  allotToVendor = (order_id, vendor_id) => {
    let vendorId = localStorage.getItem("vendorId")
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendorId}`,
    })
      .then((res) => {
        this.props.success({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        this.props.history.go();
      })
      .catch((err) => {
        console.log("shipment order failed >>> ", err.data);
        this.props.error({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  };

  undoAllotToVendor = (order_id, vendor_id) => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${order_id}/allocate/vendor/${vendor_id}/undo`,
    })
      .then((res) => {
        this.props.success({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        this.props.history.go();
      })
      .catch((err) => {
        console.log("shipment order failed >>> ", err.data);
        this.props.error({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  };

  render() {
    const { t } = this.props;
    const { openViewModal, reply, replies_fetch, isLoading, order_id, broadCastVendor, errorMessage } = this.state;
    return !isLoading && replies_fetch ? (
      <>
        <Table className="w3-small" size="small" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="p-bold-500">
                {t("vendor_name") || "Vendor Name"}
              </Table.HeaderCell>
              {
                replies_fetch.pull_rates == true &&
                <Table.HeaderCell className="p-bold-500">
                  {t("bid_amount") || "Bid Amount"}
                </Table.HeaderCell>
              }
              <Table.HeaderCell className="p-bold-500">
                {t("available_vehicle") || "Available Vehicle"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("allotment") || "Allotment"}
              </Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">{t("status") || "Status"}</Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">{"Note"}</Table.HeaderCell>
              <Table.HeaderCell className="p-bold-500">
                {t("vehicle_details") || "Vehicle Details"}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <>
              {replies_fetch.vendors.map((reply, index) => (
                <Table.Row key={index}>
                  <Table.Cell>
                    {<VendorName vendorID={reply.vendor_id} />}
                  </Table.Cell>
                  {
                    replies_fetch.pull_rates == true &&
                    <Table.Cell>
                      {(reply.vendor_interest_status.allotment_code ===
                        "INTRST" || reply.vendor_interest_status.allotment_code === "REBID" || reply.vendor_interest_status.allotment_code === "WAITINGVEH") && replies_fetch.pull_rates == true ? (
                          <p> {reply.bids.slice(0, 1).map((reply, index) => reply.bid_amount)}
                      &nbsp;
                            {reply.vendor_interest_status.allotment_code === "INTRST" ? (
                              <Button
                                type="button"
                                onClick={() => this.handleModelOpen(reply.broadcast_vendor_id)}
                                size="mini"
                                className="w3-blue w3-round w3-hover-blue"
                              >
                                {"Rebid"}
                              </Button>
                            ) : (
                                null
                                // <Button
                                //   type="button"
                                //   // onClick={() => this.handleModelOpen ( reply.broadcast_vendor_id)}
                                //   size="mini"
                                //   className="w3-blue w3-round w3-hover-blue"
                                // >
                                //   {"Cancel Rebid"}
                                // </Button>
                              )}
                          </p>
                        ) : (
                          "NA"
                        )}
                    </Table.Cell>
                  }
                  <Table.Cell>
                    {reply.available_vehicle_type ? (
                      <VehicleType VehicleId={reply.available_vehicle_type} />
                    ) : (
                        "NA"
                      )}
                  </Table.Cell>
                  <Table.Cell>
                    {reply.vendor_interest_status.allotment_code ===
                      "INTRST" || reply.vendor_interest_status.allotment_code === "REBID" ? (
                        <Button
                          type="button"
                          onClick={() =>
                            this.allotToVendor(
                              this.props.orderData.value,
                              reply.vendor_id
                            )
                          }
                          size="mini"
                          className="w3-blue w3-round w3-hover-blue"
                        >
                          {"Allot"}
                        </Button>
                      ) : reply.vendor_interest_status.allotment_code ===
                        "WAITINGVEH" ? (
                          <>
                            <Button
                              type="button"
                              onClick={() =>
                                this.undoAllotToVendor(
                                  this.props.orderData.value,
                                  reply.vendor_id
                                )
                              }
                              size="mini"
                              className="w3-blue w3-round w3-hover-blue"
                            >
                              {"Undo"}
                            </Button>
                          </>
                        ) : (
                          "NA"
                        )}
                  </Table.Cell>
                  <Table.Cell>
                    {reply.vendor_interest_status.allotment_text}
                    {reply.vendor_interest_status.allotment_code ==
                      "REJECT" && (
                        <ModalReason
                          rejectReason={reply.vendor_rejection_reason}
                        />
                      )}
                  </Table.Cell>
                  <Table.Cell>
                    {
                      <i className="far fa-file-alt"></i>
                    }
                  </Table.Cell>
                  <Table.Cell>
                    {reply.vendor_interest_status &&
                      reply.vendor_interest_status.allotment_code === "ALLOC" ||
                      reply.vendor_interest_status.allotment_code === "WAITINGVEH" ? (
                        <FormikModalVehicleDetail
                          order={reply}
                          order_id={this.props.orderData.value}
                          reFetchOrder={this.fetchOrderDetails}
                          allotment_status={reply.vendor_interest_status}
                        />
                      ) :
                      "NA"
                    }
                  </Table.Cell>
                </Table.Row>
              ))}
              {openViewModal && (
                <RebidModal
                  currenOrder={replies_fetch}
                  OpenModal={openViewModal}
                  orderID={order_id}
                  errorMessage={errorMessage}
                  textareaValue={this.getvalue}
                  broadCastVendor={broadCastVendor}
                  reFetchOrder={this.fetchVendorsReply}
                  CloseModal={() =>
                    this.setState({ openViewModal: false }, () =>
                      this.fetchVendorsReply()
                    )
                  }
                  size="mini"
                  rebidonSubmit={() => this.bitSumbit()}
                />
              )}
            </>
          </Table.Body>
        </Table>
      </>
    ) : !isLoading && !replies_fetch ? (
      <>
        <Button
          type="button"
          onClick={this.reBroadcast}
          size="mini"
          className="w3-blue w3-round w3-hover-blue"
        >
          {t("re_broadcast") || "Re Broadcast"}
        </Button>
      </>
    ) : (
          <>
            <LoadingPlaceholder />
          </>
        );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("vendor_replies")(VendorRepliesTable));
